/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuditLogDto } from '../models/audit-log-dto';
import { AuditLogDtoPage } from '../models/audit-log-dto-page';
import { getAuditLog } from '../fn/audit-logs/get-audit-log';
import { GetAuditLog$Params } from '../fn/audit-logs/get-audit-log';
import { listAuditLogs } from '../fn/audit-logs/list-audit-logs';
import { ListAuditLogs$Params } from '../fn/audit-logs/list-audit-logs';

@Injectable({ providedIn: 'root' })
export class AuditLogsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listAuditLogs()` */
  static readonly ListAuditLogsPath = '/v0/auditLogs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAuditLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAuditLogs$Response(params?: ListAuditLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<AuditLogDtoPage>> {
    return listAuditLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAuditLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAuditLogs(params?: ListAuditLogs$Params, context?: HttpContext): Observable<AuditLogDtoPage> {
    return this.listAuditLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuditLogDtoPage>): AuditLogDtoPage => r.body)
    );
  }

  /** Path part for operation `getAuditLog()` */
  static readonly GetAuditLogPath = '/v0/auditLogs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuditLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuditLog$Response(params: GetAuditLog$Params, context?: HttpContext): Observable<StrictHttpResponse<AuditLogDto>> {
    return getAuditLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuditLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuditLog(params: GetAuditLog$Params, context?: HttpContext): Observable<AuditLogDto> {
    return this.getAuditLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuditLogDto>): AuditLogDto => r.body)
    );
  }

}
